"use client";

import React from "react";
import { ArrowRight, Scale, FileText, Building2, Handshake, Briefcase } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  id: "item-1",
  title: "Contratti di Agenzia e Distribuzione",
  icon: Handshake,
  description: "Assistenza completa nella redazione e negoziazione di contratti di agenzia commerciale, distribuzione e franchising. Tuteliamo i vostri interessi nella definizione delle zone, delle esclusive e delle provvigioni, garantendo la piena conformità alle normative vigenti e prevenendo potenziali contenziosi futuri.",
  cta: "Richiedi consulenza"
}, {
  id: "item-2",
  title: "Contratti di Sub-fornitura",
  icon: FileText,
  description: "Consulenza specializzata per la gestione dei rapporti di sub-fornitura industriale. Analizziamo e redigiamo accordi che definiscono chiaramente responsabilità, tempistiche, proprietà intellettuale e standard qualitativi, elementi essenziali per mantenere una catena di fornitura efficiente e giuridicamente sicura.",
  cta: "Approfondisci"
}, {
  id: "item-3",
  title: "Locazioni e Compravendita Immobiliare",
  icon: Building2,
  description: "Supporto legale strategico per operazioni immobiliari complesse. Dalla stesura di contratti di locazione commerciale e abitativa alla gestione di compravendite e due diligence immobiliare, offriamo un'assistenza puntuale per valorizzare e proteggere il vostro patrimonio.",
  cta: "Contattaci ora"
}, {
  id: "item-4",
  title: "Contrattualistica d'Impresa",
  icon: Scale,
  description: "Redazione e revisione di accordi commerciali su misura per ogni esigenza aziendale. Ci occupiamo di condizioni generali di vendita, accordi di riservatezza (NDA), contratti di appalto e partnership strategiche, assicurando che ogni clausola sia solida e funzionale al vostro business.",
  cta: "Scopri di più"
}, {
  id: "item-5",
  title: "Operazioni Societarie e Fusioni",
  icon: Briefcase,
  description: "Assistenza qualificata in operazioni straordinarie, fusioni, acquisizioni (M&A) e riorganizzazioni societarie. Guidiamo le aziende attraverso le complessità legali delle trasformazioni aziendali, garantendo transizioni fluide e giuridicamente ineccepibili.",
  cta: "Parla con un esperto"
}];
export default function AssistanceTypes() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="tipologie-di-assistenza" ref={ref} className="bg-background py-20 lg:py-32 relative overflow-hidden">
      {}
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <div className={cn("mb-16 text-center transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <h2 className="font-serif text-4xl md:text-5xl text-foreground mb-6 tracking-tight">
            Tipologie di Assistenza
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto leading-relaxed">
            Offriamo consulenza legale specializzata per supportare la crescita e
            la stabilità della vostra impresa, con un approccio sartoriale e
            strategico.
          </p>
        </div>

        <div className={cn("transition-all duration-1000 delay-200 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          <Accordion type="single" collapsible className="w-full space-y-4">
            {services.map((service, index) => <AccordionItem key={service.id} value={service.id} data-index={index} className="border border-[var(--ring)]/30 rounded-lg px-6 bg-card/50 hover:bg-card/80 transition-colors duration-300 data-[state=open]:border-[var(--ring)] data-[state=open]:bg-card shadow-sm">
                <AccordionTrigger className="py-6 hover:no-underline group">
                  <div className="flex items-center gap-4 text-left">
                    <div className="p-2 rounded-full bg-secondary/50 text-primary group-hover:bg-[var(--ring)]/20 group-hover:text-[var(--ring)] transition-colors duration-300">
                      <service.icon className="w-5 h-5" />
                    </div>
                    <span className="font-serif text-xl text-foreground group-hover:text-primary/80 transition-colors">
                      {service.title}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pb-6 pt-2">
                  <div className="pl-[3.25rem]">
                    <p className="text-muted-foreground text-base leading-relaxed mb-6 max-w-3xl">
                      {service.description}
                    </p>
                    <Button asChild variant="outline" className="border-[var(--ring)] text-foreground hover:bg-[var(--ring)]/10 hover:text-primary transition-all duration-300 group/btn">
                      <Link to="/ConsultingPage">
                        {service.cta}
                        <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover/btn:translate-x-1" />
                      </Link>
                    </Button>
                  </div>
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}